import { jobs } from "./jobs";
import { projects } from "./projects";
import { skillCategories } from "./skillCategories";
import { generateSkillsData } from "./utils/skillsGenerator";

const skills = generateSkillsData(jobs, projects, skillCategories);

export const content = {
  jobs,
  projects,
  skills,
};

export const getRelatedContent = (skill) => {
  const related = {
    projects: [],
    jobs: [],
  };

  if (skill.relatedTo) {
    related.projects = skill.relatedTo.projects
      .map((projectId) => content.projects.find((p) => p.id === projectId))
      .filter(Boolean)
      .map((project) => ({
        id: project.id,
        name: project.title,
        link: `/projects#${project.id}`,
      }));

    related.jobs = skill.relatedTo.jobs
      .map((jobId) => content.jobs.find((j) => j.id === jobId))
      .filter(Boolean)
      .map((job) => ({
        id: job.id,
        company: job.company,
        role: job.role,
        link: `/#${job.id}`,
      }));
  }

  return related;
};
